import { useState } from "react";
import { useSearchParams } from "react-router-dom";
import { Reveal } from "@/components/site/Reveal";
import { SectionLabel, AudienceToggle, SubpageBanner } from "@/components/att/ATTShared";
import { PreorderForm } from "@/pages/ATTServicePage";

export default function ATTPreorderPage() {
  const [params] = useSearchParams();
  const initial = params.get("aud") === "business" ? "business" : "residential";
  const [tab, setTab] = useState(initial);
  return (
    <div className="py-14 md:py-20" data-testid="att-preorder-page">
      <div className="max-w-7xl mx-auto px-6 md:px-12 space-y-10">
        <Reveal>
          <SubpageBanner src="/att/og-preorder.jpg" alt="Start your AT&T pre-order" testid="att-preorder-banner" />
        </Reveal>
        <Reveal>
          <div className="flex flex-wrap items-end justify-between gap-5">
            <div>
              <SectionLabel>Pre-Order</SectionLabel>
              <h1 className="mt-4 font-serif-display text-4xl sm:text-5xl font-bold tracking-tight text-[#1d2329]">Start your pre-order.</h1>
              <p className="mt-3 max-w-2xl font-body font-light text-base text-[#3c4650]">
                No payment now — we confirm pricing, promos, and availability with you before anything is ordered.
              </p>
            </div>
            <AudienceToggle value={tab} onChange={setTab} />
          </div>
        </Reveal>
        <Reveal>
          <PreorderForm key={tab} audience={tab} />
        </Reveal>
      </div>
    </div>
  );
}
